import { convertParentData } from "./Flow";
import { calcBayesianStatsRecursive, arrSlice } from "./Maths";

/*
Converts network into exportable .net format
*/

//Given condProb, returns data in correct form for export
function exportProbs(condProb, parentData) {
  let probSets;
  const parentDataOld = convertParentData(parentData);
  if (parentDataOld.length === 0) {
    //Simple case for no parents
    probSets = calcBayesianStatsRecursive(condProb);
    let returnString = "(";
    probSets.forEach((prob, i) => {
      returnString += prob + " ";
    });
    returnString += ")";
    return returnString;
  }

  const numStates = condProb.length;
  const numStatesPerParent = parentDataOld.map(
    (p) => Object.values(p)[0].length
  );
  const numCols = numStatesPerParent.reduce((a, b) => a * b);
  probSets = getProbSets(condProb, numStates, numCols);

  //Splits the array into chunks according to the number of states per parent
  for (let i = numStatesPerParent.length - 1; i >= 0; i--) {
    probSets = arrSlice(probSets, numStatesPerParent[i]);
  }

  //Stringifies that array and changes brackets, commas etc.
  let returnString = JSON.stringify(probSets);
  returnString = returnString
    .replace(/\[/g, "(")
    .replace(/]/g, ")")
    .replace(/,/g, " ");
  returnString = returnString.substring(1, returnString.length - 1);

  return returnString;
}

//Gets sets of probabilities down columns - i.e. each set adds to 1
function getProbSets(condProb, numStates, numCols) {
  const probs = calcBayesianStatsRecursive(condProb);
  const returnProbs = [];
  let probSet;
  for (let i = 0; i < numCols; i++) {
    probSet = [];
    for (let j = 0; j < numStates; j++) {
      probSet.push(probs[i + numCols * j]);
    }
    returnProbs.push(probSet);
  }
  return returnProbs;
}

function convertID(id) {
  let newID = "ID" + id;
  newID = newID.replace(/\./g, "_");
  return newID;
}

//Exports network to .net (hugin) file format given nodes
function genExport(nds) {
  console.log("Exporting network");
  //Starts with this defining the size of each node (x y)
  //Hardcoding for now however might need to be made dynamic
  let net = "net\n{\n    node_size = (150 150);\n}\n\n";

  //Adds each node
  let nodeString;
  let statesString;
  nds.forEach((n) => {
    let newID = convertID(n.id);
    const states = n.data.states.map((s) => Object.keys(s)[0]);
    nodeString = "node " + newID + "\n{\n";
    nodeString += '    label = "' + n.data.label + '";\n';
    nodeString +=
      "    position = (" +
      parseInt(n.position.x) +
      " " +
      parseInt(n.position.y * -1) +
      ");\n";
    statesString = "    states = (";
    states.forEach((s) => {
      statesString +=
        '"' +
        s
          .split(" ")
          .filter((s) => s !== "")
          .join(" ") +
        '"';
      statesString += ", ";
    });
    statesString = statesString.substring(0, statesString.length - 2);
    statesString += ");\n";
    nodeString += statesString + "}\n\n";
    net += nodeString;
  });

  //Adds conditional probabilities for each node
  let probString;
  let parents;
  nds.forEach((n) => {
    parents = Object.values(n.data.parentData).map((p) => Object.keys(p)[0]);
    let newID = convertID(n.id);
    probString = "potential (" + newID + " | ";
    parents.forEach((p) => {
      probString += convertID(p) + " ";
    });
    probString += ")\n{\n    data = ";
    probString += exportProbs(n.data.condProb, n.data.parentData);
    probString += ";\n}\n\n";

    net += probString;
  });

  return net;
}

//Downloads the network as a .net file as generated by genExport
export function exportNetwork(nds) {
  let fileString = genExport(nds);
  // Add to top of file:
  fileString = "File generated in OLCATool\n\n" + fileString;

  const element = document.createElement("a");
  const file = new Blob([fileString], { type: "text/plain" });
  element.href = URL.createObjectURL(file);
  element.download = "network.net";
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
}
